<dx-data-grid
  #dataGrid
  id="gridContainerArticlesNonPrevus"
  class="dx-card wide-card"
  keyExpr="id"
  [dataSource]="datasource"
  [showBorders]="true"
  [allowColumnReordering]="true"
  [allowColumnResizing]="true"
  width="auto"
  (onExporting)="onExporting($event, 'bon_articles_non_prevus')"
>
<dxo-filter-row [visible]="true"></dxo-filter-row>
<dxo-header-filter [visible]="true">
  <dxo-search [enabled]="true"></dxo-search>
</dxo-header-filter>
<dxo-export [enabled]="true"></dxo-export>
<dxo-state-storing
  [enabled]="true"
  [storageKey]="'grille_bon_detail_articles_non_prevus' + (this.siteId == null ? '_globale' : this.siteId.toString())"
  appStorage
></dxo-state-storing>
<dxo-scrolling showScrollbar="always"></dxo-scrolling>

<dxo-grouping #expand [autoExpandAll]="true"></dxo-grouping>
<dxo-group-panel [visible]="true"></dxo-group-panel>

<dxo-paging [enabled]="true" [pageSize]="5"></dxo-paging>
<dxo-pager [showPageSizeSelector]="true" [allowedPageSizes]="[5, 10, 20]" [showInfo]="true" [visible]="true"></dxo-pager>
<dxo-column-chooser [enabled]="true" mode="select" [height]="600"></dxo-column-chooser>

<!-- Toolbar -->
<dxo-toolbar>
  <dxi-item>
    <div *dxTemplate>
      <dx-button icon="deletetable" hint="Réinitialiser les filtres" (onClick)="clearDatagridFilters(dataGrid)"></dx-button>
    </div>
  </dxi-item>
  <dxi-item>
    <div *dxTemplate>
      <app-reset-grid-state [dataGrid]="dataGrid"></app-reset-grid-state>
    </div>
  </dxi-item>
  <dxi-item name="exportButton"></dxi-item>
  <dxi-item name="columnChooserButton"></dxi-item>
</dxo-toolbar>

<dxi-column dataField="articleIntitule" caption="Intitulé" width="350"></dxi-column>
<dxi-column dataField="articleCodeBo" caption="Code" width="130"></dxi-column>
<dxi-column dataField="fournisseurPrincipalIntitule" caption="Fournisseur" width="150"></dxi-column>
<dxi-column caption="Unité Achat">
  <dxi-column dataField="quantiteUA" caption="Qté" width="100"></dxi-column>
  <dxi-column dataField="uniteAchat" caption="Unité" width="100"></dxi-column>
</dxi-column>
<dxi-column caption="Unité Vente">
  <dxi-column dataField="quantiteUV" caption="Qté" width="100"></dxi-column>
  <dxi-column dataField="uniteVente" caption="Unité" width="100"></dxi-column>
</dxi-column>
<dxi-column caption="Unité de Base">
  <dxi-column dataField="quantite" caption="Qté" width="100"></dxi-column>
  <dxi-column dataField="uniteBase" caption="Unité" width="100"></dxi-column>
</dxi-column>

<dxo-summary>
  <dxi-group-item
    column="quantite"
    summaryType="sum"
    valueFormat="#0.###"
    displayFormat="{0}"
    [showInGroupFooter]="false"
  >
  </dxi-group-item>
</dxo-summary>
</dx-data-grid>
